module.exports = __webpack_public_path__ + "static/media/paramedic.d8fd6ba4.jpg";